import React, { FC, ReactNode } from "react";

import styles from "./tooltip.module.css";

type TooltipProps = {
  width?: number;
  children: ReactNode;
  description: ReactNode | string;
};

const Tooltip: FC<TooltipProps> = (props) => {
  const { children, description, width } = props;
  return (
    <div className={styles.container}>
      {children}
      <div
        className={styles.tooltip}
        style={{ width: width ? `${width}px` : "132px" }}
      >
        <div>{description}</div>
      </div>
    </div>
  );
};

export default Tooltip;
